<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">  
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small"> 
          <el-form-item style="width:21%">
              <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
		  <el-form-item style="width:12%">
              <el-select v-model="query.clerkid" placeholder="按销售员" clearable @change="ischange=true">
                  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select> 
          </el-form-item> 
		  <el-form-item size="small" style="width:12%">
    			<el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="ischange=true" style="width:100%">
		          	<el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		        </el-select> 
    		</el-form-item>
          <el-form-item ref="query" :model="query" style="width:15%">
              <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" clearable @change="ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
              <!--<el-button type="danger" icon="el-icon-edit-outline">批量结算</el-button>-->
          </el-form-item>
      </el-form>
      <!------------------------search end---------------------->
      
      <el-tag type="danger" closable  @close="closetag" v-if="tagshow=='true'" style="margin-top:10px">温馨提示：应付款金额=订单总额-优惠金额+快递费</el-tag>
    
      <!-------------------------------------详情列表---------------------------------->
      <div class="backborder2" :style="csstop">
	      <el-table ref="multipleTable" :data="lists" v-loading="listLoading" @row-click="selectrow" @selection-change="handleSelectionChange">
	      	  <!--
			  <el-table-column type="selection" width="30"></el-table-column>
			  -->
	      	  <el-table-column type="expand">
	              <template slot-scope="props">
		              <el-table :data="props.row.product">
		                  <el-table-column prop="name" label="商品名称"></el-table-column>
		                  <el-table-column prop="num" label="数量" width="100" align="center"></el-table-column>
		                  <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
		                  <el-table-column prop="sell" label="价格" width="100" align="center"></el-table-column>
		                  <el-table-column prop="total" label="总价" width="100" align="center"></el-table-column>
		                  <el-table-column prop="type" label="类型" width="100" align="center"></el-table-column>
		                  <el-table-column label="状态" width="100" align="center">
			                  <template slot-scope="scope">
					              <el-tag type="success" v-if="scope.row.status==2">正常</el-tag>
					              <el-tag type="info" v-if="scope.row.status==3">退货</el-tag>
			          		  </template>
		                  </el-table-column>
		              </el-table>
	              </template>
	          </el-table-column>
	          <el-table-column prop="documents" label="订单编号" width="87"></el-table-column>
	          <el-table-column prop="customer" label="客户名称"></el-table-column>
	          <el-table-column prop="total" label="订单总价" align="center" width="105"></el-table-column>
	          <el-table-column prop="derate" label="优惠金额" align="center" width="105"></el-table-column>
	          <el-table-column prop="real" label="应付金额" align="center" width="105"></el-table-column>
	          <el-table-column prop="amount" label="已付金额" align="center" width="105"></el-table-column>
	          <el-table-column prop="express" label="邮费" align="center" width="105"></el-table-column>
	          <el-table-column prop="clerk" label="销售员" align="center" width="100"></el-table-column>
	          <el-table-column prop="inputtime" label="订单时间" width="110" align="center"></el-table-column>
	          <el-table-column label="操作" width="120" align="center">
		          <template slot-scope="scope">
		          	  <el-button type="primary" size="small" icon="el-icon-document" @click="showpay(scope.row)" circle></el-button>
		              <el-button type="danger" size="small" icon="el-icon-edit-outline" v-if="scope.row.status==2" @click="settleorder(scope.row)" circle></el-button>
		          </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>
      <!--------------------------------end--------------------------->
        
        <!------------------------结算---------------------->
        <el-dialog title="结算" :visible.sync="settleDialog" width="32%" top="5vh">
            <el-tag type="danger">温馨提示：待结算金额（包含快递费）=应付金额-已付金额</el-tag>
            <el-form ref="settle" :model="settle" label-width="100px" style="margin-top:20px" size="medium">
	            <el-col :span="22">
	                <el-form-item label="快递费" prop="total">
	                	<el-input v-model="settle.express" readonly><template slot="append">元</template></el-input>
	                </el-form-item>
	            </el-col>
                <el-col :span="22">
	                <el-form-item label="已结算金额" prop="total">
	                	<el-input v-model="settle.total" readonly><template slot="append">元</template></el-input>
	                </el-form-item>
                </el-col>
	            <el-col :span="22">
	                <el-form-item label="优惠金额" prop="total">
	                	<el-input v-model="settle.derate"><template slot="append">元</template></el-input>
	                </el-form-item>
	            </el-col>
            	<el-col :span="22">
	                <el-form-item label="待结算金额" prop="total">
	                	<el-input v-model="settle.payamount"><template slot="append">元</template></el-input>
	                </el-form-item>
            	</el-col>
            	<el-col :span="22">
	                <el-form-item label="付款方式">
		                <el-select v-model="settle.account">
		                    <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id"></el-option>
		                </el-select>
	                </el-form-item>
            	</el-col>
				<el-col :span="22">
	                <el-form-item label="收款日期">
		                <el-date-picker v-model="settle.paydate" type="date" placeholder="请选择付款日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
	                </el-form-item>
            	</el-col>
				<el-col :span="22">
	                <el-form-item label="收款备注">
		                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10}" placeholder="请输入内容" v-model="settle.desc"></el-input>
	                </el-form-item>
            	</el-col>

          	</el-form>
            <div slot="footer" class="dialog-footer">
            	<el-button size="medium" @click="settleDialog = false">取 消</el-button>
            	<el-button size="medium" type="primary" :loading="settleLoading" @click="settleSave">确 认</el-button>
            </div>
        </el-dialog>
        <!------------------------结算---------------------->
        
        <!---- 支付方式流水 ---->
    	<el-dialog title="支付记录" :visible.sync="accountlistsDialog" width="50%" top="15vh">
    		<el-table :data="paylists" style="width: 100%" border v-loading="accountlistsLoading">
				<el-table-column label="结算方式" prop="accountname" align="center"></el-table-column>
				<el-table-column label="结算金额" prop="amount" align="center"></el-table-column>
				<el-table-column label="结算时间" prop="inputtime" align="center"></el-table-column>
      		</el-table>
      		<div slot="footer" class="dialog-footer">
	        	<el-button size="medium" @click="accountlistsDialog=false">取 消</el-button>
	    	</div>
    	</el-dialog>
         
    </div>
    </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      listLoading:false,
      settleLoading:false,
      settleDialog:false,
      settleLoading:false,
      lists:[],
      sellerLists:[],
	  ischange:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        date:[],
        clerkid:'',
		customerid:'',
        account:'01',
      },
      settle: {
      	act:'settleorder',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        total:'',
        derate:'',
        payamount:'',
        express:'',
        account:'',
		paydate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
		desc:'',
      },
      accountLists:[],
      total_rows: 0,
      pclickstatus:[],
      multipleSelection:[],
      accountlistsLoading:false,
      accountlistsDialog:false,
      paylists:[],
      tagshow:'true',
      csstop:{'margin-top':'10px'},
	  customerLoading:false,
	  customerLists:[],


    }
  },
  mounted(){
      this.getList();
      this.getSeller();
      this.getAccount();
  },
  methods:{
  
  	  closetag() {
  	      this.tagshow='false';
  	  },
  
  	  /** 获取未支付订单信息 **/
      getList(){
		  if(this.ischange==true) {
			  this.query.p=1;
			  this.query.rollpage=10;
		  }

      	  this.listLoading = true;
      	  var resource = this.$resource(this.url);
      	  resource.save(this.query).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001'){
		            this.$router.push('/login')
		          }
		          this.$message.error(res.data.Message);
		          this.listLoading = false;
	          }else{
		          this.lists = JSON.parse(Base64.decode(res.data.Data));		          
		          this.total_rows=parseInt(res.data.count);
		          this.listLoading = false;
		          
		          var _this=this;
                  this.pclickstatus=[];
	              this.lists.forEach(function() {_this.pclickstatus.push(0)});	
				  if(this.ischange==true) this.ischange=false;  
	          }
      	  }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.listLoading=false;
          });
      },
      pageSizeChange(val) {
          this.query.rollpage = val;
          this.getList();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },
      
      /** 获取销售员 **/
      getSeller(){
      	  var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
      	  resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
          	this.$message.error(this.GLOBAL.errortext);
          });
      },

	    /** 获取客户 **/
		getCustomer(query){
			if (query !== '') {
				this.customerLoading = true;
				var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
				resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
						this.customerLoading = false;
					}else{
						this.customerLists = JSON.parse(Base64.decode(res.data.Data));
						this.customerLoading = false;
					}
				}).catch((res) => {
					//this.$message.error(this.GLOBAL.errortext);
					this.customerLoading = false;
				});
			}
		},
      
      
      /** 结算 （获取已结算金额和待结算金额）**/
      settleorder(item) {
      	  var resource = this.$resource(this.url);
      	  resource.query({act:'checkaccount',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  var obj = JSON.parse(Base64.decode(res.data.Data));
	          	  this.settle.id=item.id;
			      this.settle.name=item.customer;
			      this.settle.total=obj.total;
			      this.settle.express=obj.express;
			      this.settle.payamount=obj.payamount;
			      this.settle.derate=obj.derate;
			      this.settle.basederate=obj.derate;
			      this.settle.basepayamount=obj.payamount;
				  this.settle.paydate=new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate();
				  this.settle.desc='';
			      this.settleDialog=true;
	          }
          }).catch((res) => {
          	  //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      /** 确认结算 **/
      settleSave() {
          this.settleLoading=true;
	      var resource = this.$resource(this.url);
	      resource.save(this.settle).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.settleLoading=false;
	          }else{
	              this.$message.success(res.data.Message);
	              this.settleDialog=false;
	              this.settleLoading=false;
	              this.getList();
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.settleDialog=false;
	          this.settleLoading=false;
	      });
      },
      
      
      /** 获取银行卡号 **/
      getAccount(){
	      var resource = this.$resource(this.GLOBAL.domain+"Account/index");
	      resource.query({act:'lists',isdeposit:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      /** 点击单行触发事件 **/
	  selectrow(row,event,column) {
	      var id=row.id;
	      var number=0;
	      var dindex=0;
	      var isselect=0;
	      var _this=this;
	    	
	      //获取当前商品在商品列表里的位置
	      this.lists.forEach(function(e,index) {if(id==e.id) number=index});
	      //给该位置进行勾选或取消勾选
	      this.pclickstatus[number]==0 ? this.pclickstatus[number]=1 : this.pclickstatus[number]=0;
		  //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		  this.$refs.multipleTable.toggleRowSelection(this.lists[number]);
	  },
	  
	  /** 订单列表选择有变动时触发 **/
      handleSelectionChange(val) {
    	  var _this=this;
    	  this.multipleSelection=[]; //清空获取的订单id
		  val.forEach(function(item,i) {_this.multipleSelection.push(item.id)}); //获取已选中的订单id
		  this.lists.forEach(function(item,i) { //更新商品的状态
			  //查询订单id在选中的数组里是否存在
			  _this.multipleSelection.indexOf(item.id)!=-1 ? _this.pclickstatus[i]=1 : _this.pclickstatus[i]=0;
		  }); 	    	
      },
      
      /** 展示支付记录 **/
      showpay(item) {
	      this.accountlistsLoading=true;
	      var resource = this.$resource(this.url);
		  resource.query({act:'showaccountlists',id:item.id,type:2,token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
			      if(res.data.Result=='70001') this.$router.push('/login')
			      this.$message.error(res.data.Message);
			      this.accountlistsLoading=false;
			  }else{
			      this.paylists = JSON.parse(Base64.decode(res.data.Data));
			      this.accountlistsLoading=false;
			      this.accountlistsDialog=true;
			  }
		  }).catch((res) => {
		      this.accountlistsLoading=false;
		  });
      },
      
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Account.vue